/* eslint-disable no-throw-literal */
import { STUDY_DASHBOARD_ENDPOINT, STUDY_HEARTBEAT_ENDPOINT, STUDY_SECURED_HEARTBEAT_ENDPOINT, STUDY_UTILIZATION_RATES_ENDPOINT, STUDY_UTILIZATION_RATES_PROCEDURE_ENDPOINT, STUDY_UTILIZATION_SECURED_HEARTBEAT_ENDPOINT } from "../config/api-endpoints";
import { authorizeHeader } from "../utils/auth-header";


export const getActiveStudyAPICall = async (requestBody) => {
    try {
      const config = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
      }
      const url = STUDY_DASHBOARD_ENDPOINT + "active/"
      const response = await window.fetch(url, authorizeHeader(config))
      const responseStatus = await response.status
      let responseJSON;
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        responseJSON = await response.json()
      } else{
        throw {
          responseStatus,
          message: `${responseStatus} Response is not a JSON.`
        };
      }
      return { responseStatus, responseJSON }
    } catch (e) {
      console.error(e.message)
      return e
    }
}


export const getDetailStudyAPICall = async (requestBody) => {
    try {
      const config = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
      }
      const url = STUDY_DASHBOARD_ENDPOINT + "details/"
      const response = await window.fetch(url, authorizeHeader(config))
      const responseStatus = await response.status
      let responseJSON;
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        responseJSON = await response.json()
      } else{
        throw {
          responseStatus,
          message: `${responseStatus} Response is not a JSON.`
        };
      }
      return { responseStatus, responseJSON }
    } catch (e) {
      console.error(e.message)
      return e
    }
}

export const getPerFacilityStudyAPICall = async (requestBody) => {
    try {
      const config = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
      }
      const url = STUDY_DASHBOARD_ENDPOINT + "counts/per-facility/"
      const response = await window.fetch(url, authorizeHeader(config))
      const responseStatus = await response.status
      let responseJSON;
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        responseJSON = await response.json()
      } else{
        throw {
          responseStatus,
          message: `${responseStatus} Response is not a JSON.`
        };
      }
      return { responseStatus, responseJSON }
    } catch (e) {
      console.error(e.message)
      return e
    }
}


export const getHeartBeatAPICall = async (requestBody) => {
    try {
      const config = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
      }
      const url = STUDY_HEARTBEAT_ENDPOINT
      const response = await window.fetch(url, authorizeHeader(config))
      const responseStatus = await response.status
      let responseJSON;
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        responseJSON = await response.json()
      } else{
        throw {
          responseStatus,
          message: `${responseStatus} Response is not a JSON.`
        };
      }
      return { responseStatus, responseJSON }
    } catch (e) {
      console.error(e.message)
      return e
    }
}


export const getSecuredHeartBeatAPICall = async (requestBody) => {
    try {
      const config = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
      }
      const url = STUDY_SECURED_HEARTBEAT_ENDPOINT
      const response = await window.fetch(url, authorizeHeader(config))
      const responseStatus = await response.status
      let responseJSON;
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        responseJSON = await response.json()
      } else{
        throw {
          responseStatus,
          message: `${responseStatus} Response is not a JSON.`
        };
      }
      return { responseStatus, responseJSON }
    } catch (e) {
      console.error(e.message)
      return e
    }
}

export const getUtilizationSecuredHeartBeatAPICall = async (requestBody) => {
    try {
      const config = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
      }
      const url = STUDY_UTILIZATION_SECURED_HEARTBEAT_ENDPOINT
      const response = await window.fetch(url, authorizeHeader(config))
      const responseStatus = await response.status
      let responseJSON;
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        responseJSON = await response.json()
      } else{
        throw {
          responseStatus,
          message: `${responseStatus} Response is not a JSON.`
        };
      }
      return { responseStatus, responseJSON }
    } catch (e) {
      console.error(e.message)
      return e
    }
  }


export const getUtilizationRatesChartBeatAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    }
    const url = STUDY_UTILIZATION_RATES_ENDPOINT +"/chart?from_date=2001-01-01&to_date=2023-01-01"
    const response = await window.fetch(url, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const getUtilizationRatesBeatAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    }
    const url = STUDY_UTILIZATION_RATES_ENDPOINT + "?from_date=2001-01-01&to_date=2023-01-01"
    const response = await window.fetch(url, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

export const getUtilizationRatesProcedureAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    }
    const url = STUDY_UTILIZATION_RATES_PROCEDURE_ENDPOINT + "?from_date=2001-01-01&to_date=2023-01-01"
    const response = await window.fetch(url, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

export const getUtilizationRatesProcedureChartAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    }
    const url = STUDY_UTILIZATION_RATES_PROCEDURE_ENDPOINT + "/chart?from_date=2001-01-01&to_date=2023-01-01"
    const response = await window.fetch(url, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}